import type { Map } from 'mapbox-gl'
import type { InjectionKey, Ref } from 'vue'

export const mapSymbol: InjectionKey<Ref<Map>> = Symbol('livePanelMap')
export const mapZoomSymbol: InjectionKey<Ref<number>> = Symbol('livePanelMapZoom')
export const mapLoadedSymbol: InjectionKey<Ref<boolean>> = Symbol('livePanelMapLoaded')
